function OffenderAbsenceScheduleDisplay(aSchedule) {
    this.isRecurring = aSchedule.isRecurring;
    this.daysOfWeek = displayDaytoDay(aSchedule.start, aSchedule.end);
    this.overrideDay = DisplaySuperShortMomentDate(aSchedule.start);
    this.startTime = aSchedule.start.format("h:mm:ss a");
    this.endTime = aSchedule.end.format("h:mm:ss a");
    this.id = aSchedule._id;
    this.title = aSchedule.title;
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderAbsenceScheduleDisplay;
}